<template>
  <a-spin :spinning="pageLoading" tip="Loading...">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-card class="m-card-transparent margin-bottom">
          <label slot="title">Contract Information</label>
          <a-form :form="form">
            <a-form-item label="Contract number">
              <a-input
                v-decorator="[
                  'nomor_kontrak',
                  { initialValue: initialData.nomor_kontrak },
                ]"
              ></a-input>
            </a-form-item>
            <a-form-item label="Contract Title">
              <a-input
                v-decorator="[
                  'judul_kontrak',
                  { initialValue: initialData.judul_kontrak },
                ]"
              ></a-input>
            </a-form-item>
            <a-form-item label="Contract Date">
              <a-date-picker
                placeholder="Select Date"
                :format="getDefaultDateFormat"
                v-decorator="[
                  'tanggal_kontrak',
                  {
                    initialValue: moment(
                      initialData.tanggal_kontrak,
                      getStandartFormatDate
                    ),
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="Document">
              <a-upload
                :showUploadList="false"
                :fileList="push"
                listType="picture"
                :beforeUpload="beforeUpload"
                v-decorator="['file_dokumen', { valuePropName: 'push' }]"
              >
                <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
              </a-upload>
            </a-form-item>
            <a-card>
              <label slot="title">Contract Document</label>
              <div
                class="m-display-flex space-between align-middle"
                v-if="
                  (mode === 'Edit' && data.dokumen !== '') || push.length > 0
                "
              >
                <h4>{{ fileUpload.name }}</h4>
                <a-button
                  type="danger"
                  @click="handleRemove()"
                  icon="delete"
                  size="small"
                ></a-button>
              </div>
              <a-alert
                v-else
                type="error"
                message="No contract documents uploaded"
                banner
              />
            </a-card>
          </a-form>
        </a-card>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-card class="m-card-transparent">
          <label slot="title"
            >Information
            {{ info === "Repeat Order" ? "Product" : "Work" }}</label
          >
          <a-form :form="formDetail">
            <a-form-item label="Job Name" v-if="info === 'Project Based'">
              <a-input
                v-decorator="[
                  'nama_produk',
                  {
                    rules: [{ required: true }],
                    initialValue: dataList.nama_produk,
                  },
                ]"
              ></a-input>
            </a-form-item>
            <a-form-item label="Product name" v-else>
              <a-select
                showSearch
                :filter-option="filterOptionProduk"
                option-filter-prop="children"
                v-decorator="[
                  'nama_produk',
                  {
                    rules: [{ required: true }],
                    initialValue: dataList.nama_produk,
                  },
                ]"
              >
                <a-select-option v-for="item in produk" :key="item.produk_nm">{{
                  item.produk_nm
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-row :gutter="16">
              <a-col span="12">
                <a-form-item label="Quantity">
                  <a-input-number
                    type="number"
                    :min="1"
                    class="m-width-full m-text-align-right"
                    :formatter="
                      (value) =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    "
                    v-decorator="[
                      'jumlah',
                      {
                        rules: [{ required: true }],
                        initialValue: dataList.anggaran_produksi,
                      },
                    ]"
                  />
                </a-form-item>
              </a-col>
              <a-col span="12">
                <a-form-item label="Unit">
                  <a-auto-complete
                    :dataSource="initialSatuan"
                    placeholder="input here"
                    v-decorator="['satuan', { rules: [{ required: true }] }]"
                    :filterOption="handleSatuan"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item>
              <a-button type="primary" block @click="handleNew">Add</a-button>
            </a-form-item>
          </a-form>
        </a-card>
        <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <h4 slot="header" class="margin-remove">View Details</h4>
            <a-list
              itemLayout="vertical"
              :dataSource="dataList"
              :pagination="pagination"
            >
              <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <a-row slot="title" type="flex" justify="space-between">
                    <a href="#">{{ item.nama_produk }}</a>
                  </a-row>
                  <p slot="description">
                    {{ item.jumlah + " " + item.satuan }}
                  </p>
                </a-list-item-meta>
                <a-button-group>
                  <a-button type="primary" @click="handleEditModal(item)">
                    <a-icon type="edit" />&nbsp; Edit
                  </a-button>
                  <a-button type="danger" @click="handleRemoveDetail(item)">
                    <a-icon type="close" />&nbsp; Remove
                  </a-button>
                </a-button-group>
              </a-list-item>
            </a-list>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </a-row>
    <a-modal v-model="editModal" @ok="handleEditModal" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;Change Product </span>

      <a-form :form="formDetailModal">
        <a-form-item label="Product Name">
          <a-select
            disabled
            showSearch
            v-decorator="[
              'nama_produk',
              {
                rules: [{ required: true }],
                initialValue: editData.nama_produk,
              },
            ]"
          >
            <a-select-option
              v-for="item in produk"
              :key="item.produk_id"
              :value="item.produk_nm"
              >{{ item.produk_nm }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-row :gutter="8">
          <a-col :span="12">
            <a-form-item label="Quantity">
              <a-input-number
                :min="1"
                :max="10000"
                class="m-width-full"
                v-decorator="[
                  'jumlah',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.jumlah,
                  },
                ]"
              ></a-input-number>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="Unit">
              <a-select
                showSearch
                @change="handleSatuan"
                v-decorator="[
                  'satuan',
                  {
                    rules: [{ required: true }],
                    initialValue: editData.satuan,
                  },
                ]"
              >
                <a-select-option
                  v-for="item in initialSatuan"
                  :key="item"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleModalEdit"
            block
            type="danger"
            html-type="submit"
            >Change</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
export default {
  name: "informasi",
  props: {
    info: "",
    data: {},
    mode: "",
  },
  data() {
    return {
      editModal: false,
      pageLoading: true,
      produk: [],
      satuan: [],
      push: [],
      dataList: [],
      editData: [],
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      fileUpload: {
        name: "",
      },
      pushsts: false,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formDetail = this.$form.createForm(this);
    this.formDetailModal = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    initialData() {
      let data = {};
      if (this.data === undefined || this.data.length <= 0) {
        data = {
          nomor_kontrak: "",
          judul_kontrak: "",
          tanggal_kontrak: moment(),
          jenis: this.info,
        };
      } else {
        if (this.mode === "Create") {
          data = {
            nomor_kontrak: this.data.kontrak.nomor_kontrak,
            judul_kontrak: this.data.kontrak.judul_kontrak,
            tanggal_kontrak: this.data.kontrak.tanggal_kontrak,
            jenis: this.info,
          };
        } else if (this.mode === "Edit") {
          data = {
            nomor_kontrak: this.data.nomor_kontrak,
            judul_kontrak: this.data.judul,
            tanggal_kontrak: this.data.tanggal_kontrak,
            jenis: this.info,
          };
        }
      }

      return data;
    },
    initialSatuan() {
      let satuan = [];
      this.satuan.forEach((item) => {
        satuan.push(item["satuan"]);
      });

      return satuan;
    },
  },
  created() {
    this.fetchingSatuan();
    this.fetchProduk();
  },
  mounted() {
    if (this.mode === "Edit") {
      const dataListeVal = this.data.detil_kontrak
        ? this.data.detil_kontrak
        : this.data.detail_list;

      let keyforEach = 0;
      dataListeVal.forEach((item) => {
        this.dataList = [
          ...this.dataList,
          {
            keyIndex: keyforEach,
            jumlah: item.jumlah,
            nama_produk: item.nama_produk,
            satuan: item.satuan,
          },
        ];
        keyforEach++;
      });
      if (this.data.dokumen !== "") {
        this.fileUpload.name = this.data.dokumen;
      } else {
        this.fileUpload.name = "";
      }
    }
    if (this.mode === "Create") {
      const dataListeVal = this.data
        ? this.data.detail_list && this.data.detail_list.length > 0
          ? this.data.detail_list
          : []
        : [];

      let keyforEach = 0;
      dataListeVal.forEach((item) => {
        this.dataList = [
          ...this.dataList,
          {
            keyIndex: keyforEach,
            jumlah: item.jumlah,
            nama_produk: item.nama_produk,
            satuan: item.satuan,
          },
        ];
        keyforEach++;
      });
    }
    if (this.data && this.data.pushsts === true) {
      this.pushsts = true;
    }

    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("confirmMessageDeleteDetil", this.deleteDetil);
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("confirmMessageDeleteDetil", this.deleteDetil);
  },
  methods: {
    moment,
    handleSatuan(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    fetchProduk() {
      axios({
        method: "get",
        url: this.$serviceUrl + "project/produkGroupbyProduk_nm",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.produk = response.data.data;
          this.pageLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchingSatuan() {
      axios({
        method: "get",
        url: this.$serviceUrl + "project/produk_satuan",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.satuan = response.data.data;
          this.pageLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleNew() {
      this.formDetail.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        const findName = this.dataList.filter(
          (item) => item.nama_produk === values.nama_produk
        );

        if (findName.length > 0) {
          this.displayMessage("form-duplicate");
          return;
        } else {
          let keyIndex = this.dataList.length + 1;
          const value = {
            keyIndex: keyIndex,
            nama_produk: values.nama_produk,
            jumlah: values.jumlah,
            satuan: values.satuan,
          };
          this.dataList = [...this.dataList, value];
          this.formDetail.resetFields();
        }
      });
    },
    handleRemoveDetail(item) {
      this.confirmMessageValue("confirm-delete-detil", item);
    },
    deleteDetil(item) {
      const index = this.dataList.indexOf(item);
      const newFileList = this.dataList.slice();
      newFileList.splice(index, 1);
      this.dataList = newFileList;
    },
    handleRemove() {
      if (this.mode === "Edit") {
        if (this.data.dokumen !== "") {
          this.confirmMessageValue("confirm-delete", undefined);
        } else {
          this.push = [];
          this.fileUpload.name = "";
        }
      } else {
        this.push = [];
        this.fileUpload.name = "";
      }
    },
    delete() {
      if (this.pushsts === true) {
        this.push = [];
        this.fileUpload.name = "";
        this.data.dokumen = "";
      } else {
        const serviceUrl = this.$serviceUrl;
        const name = this.data.dokumen;
        const auth = {
          username: this.getAuth.username,
          password: this.getAuth.password,
          apikey: this.getAuth.apikey,
        };
        axios({
          method: "delete",
          url: serviceUrl + "project/file_dokumen",
          processData: false,
          data: {
            file_dokumen: name,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            Event.$emit("refresh", true);
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.mode === "Edit") {
          if (this.data.dokumen !== "") {
            this.displayMessage("form-duplicate-contract");
          }
        }

        let slice = [...this.push, file];
        this.fileUpload.name = file.name;
        slice = slice.slice(-1);
        this.push = slice;
        this.pushsts = true;
        return false;
      }
    },
    handleRef() {
      let kontrak = this.form.getFieldsValue();
      kontrak.tanggal_kontrak = moment(kontrak.tanggal_kontrak).format(
        this.getStandartFormatDate
      );
      Event.$emit("projectrab", {
        file_upload: this.push,
        kontrak: JSON.parse(JSON.stringify(kontrak)),
        detail_list: this.dataList,
      });
    },
    handleRefBack() {
      let kontrak = this.form.getFieldsValue();
      kontrak.tanggal_kontrak = moment(kontrak.tanggal_kontrak).format(
        this.getStandartFormatDate
      );
      Event.$emit("projectrabBack", {
        file_upload: this.push,
        kontrak: JSON.parse(JSON.stringify(kontrak)),
        detail_list: this.dataList,
        nomor_kontrak: kontrak.nomor_kontrak,
        judul: kontrak.judul_kontrak,
        tanggal_kontrak: kontrak.tanggal_kontrak,
        jenis: this.info,
        dokumen: this.fileUpload.name,
        pushsts: this.pushsts,
      });
    },
    handleEditModal(item) {
      this.editData = item;
      this.editModal = !this.editModal;
    },
    handleModalEdit() {
      this.formDetailModal.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        this.handleModalItem(values);
        this.editModal = !this.editModal;
      });
      this.formDetailModal.resetFields();
    },
    handleModalItem(items) {
      console.log(this.dataList);
      console.log(this.editData.nama_produk);
      const newPush = this.dataList.filter(
        (item) => item.nama_produk !== this.editData.nama_produk
      );
      console.log(newPush);
      this.dataList = newPush;

      const values = {
        keyIndex: this.editData.keyIndex,
        nama_produk: items.nama_produk,
        jumlah: items.jumlah,
        satuan: items.satuan,
      };

      this.dataList = [...this.dataList, values];
      console.log(this.dataList);
      //ascending
      this.dataList.sort(function (a, b) {
        return a.keyIndex - b.keyIndex;
      });

      this.formDetail.resetFields();
    },
    filterOptionProduk(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>

<style lang="less" scoped>
</style>